import { AfterViewInit, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { AuthService } from '../../services/auth.service';
import { ObjectUpdatePayload } from '../../models/screeningInvite';
import { Client } from '../../clients-module/models/clientLocation';
import { ClientService } from '../../clients-module/services/client.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-riq-slider',
  templateUrl: './riq-slider.component.html',
  styleUrls: ['./riq-slider.component.less']
})


export class RiqSliderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatTable, {read: ElementRef, static: true} ) private matTableRef: ElementRef;
  @Input() recDecAccept: number;
  @Input() recDecConditionalHigh: number;
  @Input() recDecConditionalLow: number;
  @Input() model: Client;
  @Output() changed = new Subject<any>();
  @Input() refreshTrigger: EventEmitter<boolean>;
  refreshSub$: Subscription;

  updates : ObjectUpdatePayload[] = [];

  displayedColumns: string[] = [];
  dataSource = [];
  columns = [];

  pressed = false;
  currentResizeIndex: number;
  startX: number;
  startWidth: number;
  isResizingRight: boolean;
  resizableMousemove: () => void;
  resizableMouseup: () => void;

  constructor(
    private renderer: Renderer2,
    public auth : AuthService, 
    public clients : ClientService, 
  ) { }
  ngOnDestroy(): void {
    if(this.refreshSub$) this.refreshSub$.unsubscribe();
  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    this.setSliderValues();  
    if(this.refreshTrigger) {
      this.refreshSub$ = this.refreshTrigger.subscribe(on => {
      console.log('RESETTIN SLIDER VALUES');
      this.setSliderValues();
      },
      err =>{},
      () => {})
    }
  }

  setTableResize(tableWidth: number) {
    this.refreshColumns();
    var totWidth = 0;
    this.columns.forEach(( column) => {
      totWidth += column.width;
    });
    const scale = (tableWidth - 5) / totWidth;
    this.columns.forEach(( column) => {
      column.width *= scale;
      this.setColumnWidth(column);
    });
  }

  refreshColumns() {
    this.columns = [
      //NOTE: OLD COLUMN DEFS WITH DEFAULTS, LEAVING FOR THE TIME BEING
      // { field: 'decline', property: 'recDecDecline', width: this.recDecConditionalLow ? ((this.recDecConditionalLow-1)/100) : .45, },
      // { field: 'conditional-low', property: 'recDecConditionalLow', width: this.recDecConditionalLow ? (this.recDecConditionalHigh/100)-(this.recDecConditionalLow/100)-.01 : .3, },
      // { field: 'conditional-high', property: 'recDecConditionalHigh', width: this.recDecConditionalHigh ? (this.recDecAccept/100)-(this.recDecConditionalHigh/100) : .1, },
      // { field: 'accept', property: 'recDecAccept', width: this.recDecAccept ? 1-(this.recDecAccept/100)-.01 : .15, }
      { field: 'decline', property: 'recDecDecline', width: (this.recDecConditionalLow)/100 },
      { field: 'conditional-low', property: 'recDecConditionalLow', width: (this.recDecConditionalHigh/100)-(this.recDecConditionalLow/100) },
      { field: 'conditional-high', property: 'recDecConditionalHigh', width: (this.recDecAccept/100)-(this.recDecConditionalHigh/100) },
      { field: 'accept', property: 'recDecAccept', width: 1-(this.recDecAccept/100) }
    ];
  }

  setDisplayedColumns() {
    this.columns.forEach(( column, index) => {
      column.index = index;
      this.displayedColumns[index] = column.field;
    });
  }

  onResizeColumn(event: any, index: number) {
    this.checkResizing(event, index);
    this.currentResizeIndex = index;
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = event.target.clientWidth;
    event.preventDefault();
    this.mouseMove(index);
  }

  private checkResizing(event, index) {
    const cellData = this.getCellData(index);
    if ( ( index === 0 ) || ( Math.abs(event.pageX - cellData.right) < cellData.width / 2 &&  index !== this.columns.length - 1 ) ) {
      this.isResizingRight = true;
    } else {
      this.isResizingRight = false;
    }
  }

  private getCellData(index: number) {
    const headerRow = this.matTableRef.nativeElement.children[0];
    const cell = headerRow.children[index];
    return cell.getBoundingClientRect();
  }

  mouseMove(index: number) {
    this.resizableMousemove = this.renderer.listen('document', 'mousemove', (event) => {
      if (this.pressed && event.buttons ) {
        const dx = (this.isResizingRight) ? (event.pageX - this.startX) : (-event.pageX + this.startX);
        const width = this.startWidth + dx;
        if ( this.currentResizeIndex === index && width > 0 ) {
          this.setColumnWidthChanges(index, width);
        }
      }
    });
    this.resizableMouseup = this.renderer.listen('document', 'mouseup', (event) => {
      if (this.pressed) {
        this.pressed = false;
        this.currentResizeIndex = -1;
        this.resizableMousemove();
        this.resizableMouseup();
      }
    });
  }

  setColumnWidthChanges(index: number, width: number) {
    const orgWidth = this.columns[index].width;
    const dx = width - orgWidth;
    if ( dx !== 0 ) {
      const j = ( this.isResizingRight ) ? index + 1 : index - 1;
      const newWidth = this.columns[j].width - dx;
      if ( newWidth > 0 ) {
          this.columns[index].width = width;
          this.setColumnWidth(this.columns[index]);
          this.columns[j].width = newWidth;
          this.setColumnWidth(this.columns[j]);
        }
    }
  }

  setColumnWidth(column: any) {
    let totWidth = 0;
    const columnEls = Array.from( document.getElementsByClassName('mat-column-' + column.field) );
    columnEls.forEach(( el: HTMLDivElement ) => {
      el.style.width = column.width*.8 + 'px';
    });
    this.setColumnValues();
  }

  setColumnValues() {
    let tableWidth = this.matTableRef.nativeElement.clientWidth;
    let totalValue = -1;
    let prevValue = 0;
    this.columns.forEach(( column) => {
      const columnEls = Array.from( document.getElementsByClassName('mat-column-' + column.field) );
      columnEls.forEach(( el: HTMLElement ) => {
        totalValue += Math.round((column.width/tableWidth)*100);
        if (totalValue > 97) {
          totalValue = 100;
        }
        el.innerHTML = prevValue.toString() + '-' + totalValue.toString();
        // if (column.field == 'conditional-low') {
        //   this.model.recDecConditionalLow = prevValue;
        // }
        // if (column.field == 'conditional-high') {
        //   this.model.recDecConditionalHigh = prevValue;
        // }
        // if (column.field == 'accept') {
        //   this.model.recDecAccept = prevValue;
        // }
        prevValue += Math.round((column.width/tableWidth)*100);
      });
    });
  }

  public setSliderValues() {
    this.refreshColumns();
    this.setDisplayedColumns();

    //RIQ-3528: as of this angular update, we need a little extra lag before calling this method to allow for all the els to load, otherwise the slider collapses and is useless
    setTimeout(() => {
      this.setTableResize(this.matTableRef.nativeElement.clientWidth);
    }, 200);  
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setTableResize(this.matTableRef.nativeElement.clientWidth);
  }
}